export const ROLES = {
  SYSTEM_ADMIN: "system-admin",
};
